import { actionOn, thunk } from 'easy-peasy'
import QUESTION_TYPE, { QUESTION_REL_KEY } from '@v4/constants/questions'
import { PAGE_COMPONENT, QUERY_PARAMS_TO_DELETE } from '@v4/constants/general'
import ROUTES from '@v4/constants/route'
import scoreappApi from '@v4/api/scoreappApi'
import { openWindow } from '@v4/utils/general'
import Tracking from '@v4/utils/tracking'
import { TrackingEvents } from '@v4/constants/tracking'

export const createSignUpModel = (initialData, component) => {
	const data = { [QUESTION_TYPE.CHECKBOX]: [], [QUESTION_TYPE.HIDDEN]: [], [QUESTION_TYPE.OTHER]: [] }

	return {
		data: initialData.questions
			? initialData.questions.reduce((acc, item) => {
					const relKEy = QUESTION_REL_KEY[item.answer_type]
					if (acc[relKEy]) acc[relKEy].push(_.cloneDeep(item))
					return acc
			  }, data)
			: data,
		answers: _.cloneDeep(initialData.answers || []),

		singUp: thunk(async (actions, { values, analyticData }, { getStoreState }) => {
			const queryString = new URLSearchParams(window?.location.search)
			const fbadId = queryString.get('fbad_id')

			await scoreappApi.post('start', fbadId ? { ...values, fbad_id: fbadId } : values)

			Tracking.track(TrackingEvents.LEAD, analyticData)

			const {
				general: { basename, targetWindow },
				tokens: { sasid },
			} = getStoreState()

			const pathname = `${basename}${ROUTES.QUESTIONS}`

			const isAutoStart = component === PAGE_COMPONENT.AUTO_START

			queryString.delete('target')

			if (sasid && (queryString.has('SASID') || window !== window.top)) {
				queryString.set('SASID', sasid)
			}

			if (targetWindow === '_top') {
				_.forEach(QUERY_PARAMS_TO_DELETE, param => queryString.delete(param))
			}

			const autoStartSearch = queryString.has('SASID') ? `SASID=${queryString.get('SASID')}` : null

			openWindow(
				{
					origin: window?.location.origin,
					pathname,
					search: isAutoStart ? autoStartSearch : queryString.toString(),
				},
				targetWindow,
			)
		}),
		completeSingUp: thunk(async (actions, { pageId, values }, { getStoreState }) => {
			const resultKey = getStoreState().result.data.key
			const response = await scoreappApi.post(`pages/${pageId}/complete-sign-up/${resultKey}`, values)

			return response.data
		}),
		prefill: thunk(async (actions, payload, { getStoreState }) => {
			const resultKey = getStoreState().result.data.key
			const response = await scoreappApi.put(`results/${resultKey}/prefill`, payload)

			return response.data
		}),
		updateSingUp: thunk(async (actions, { pageId, values }, { getStoreState }) => {
			const resultKey = getStoreState().result.data.key
			const response = await scoreappApi.put(`pages/${pageId}/update-sign-up/${resultKey}`, values)

			return response.data
		}),

		onSuccessSingUp: actionOn(
			actions => [actions.completeSingUp.successType, actions.updateSingUp.successType],
			(state, { resolvedTargets, type, result: { answers }, payload: { analyticData } }) => {
				const [completeSuccessType, updateSuccessType] = resolvedTargets

				state.answers = answers

				if (type === completeSuccessType) {
					Tracking.track(TrackingEvents.LEAD, analyticData)
				}

				if (type === updateSuccessType) {
					Tracking.track(TrackingEvents.LEAD_DETAILS_UPDATED, analyticData)
				}
			},
		),
	}
}
